import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setGoogleAuth } from "../../../utils/store/reducers/authSlice";
import { Spin } from "antd";
import toast from "react-hot-toast";
import "./style.scss";

const AdminLogin = () => {
  const { idToken, refreshToken, uid } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!idToken || !refreshToken) {
      setError("Missing authentication tokens. Please try logging in again.");
      toast.error(
        "Missing authentication tokens. Please try logging in again.",
        {
          position: "top-right",
          autoClose: 2000,
          theme: "dark",
          className: "custom-toast-container",
        }
      );
      return;
    }

    const authenticate = async () => {
      try {
        await dispatch(
          setGoogleAuth({
            idToken: idToken,
            refreshToken: refreshToken,
            uid: uid || 123,
          })
        ).unwrap(); // Assuming setGoogleAuth is a thunk that returns a promise
      } catch (err) {
        setError("Authentication failed. Please try again.");
        toast.error("Authentication failed. Please try again.", {
          position: "top-right",
          autoClose: 2000,
          theme: "dark",
          className: "custom-toast-container",
        });
      }
    };

    authenticate();

    // Timeout to redirect if authentication doesn't complete
    const timeoutId = setTimeout(() => {
      if (!isAuthenticated) {
        setError("Authentication timed out. Please try again.");
        toast.error("Authentication timed out. Please try again.", {
          position: "top-right",
          autoClose: 2000,
          theme: "dark",
          className: "custom-toast-container",
        });
        navigate("/login");
      }
    }, 10000); // 10 seconds timeout

    return () => clearTimeout(timeoutId);
  }, [idToken, refreshToken, dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      const redirectPath =
        window.location.pathname === "/signup"
          ? "/funding-evaluation/plans/0"
          : "/";
      navigate(redirectPath);
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="admin-login-container">
      {error ? (
        <div className="error-message">
          <h3>{error}</h3>
          <button className="retry-button" onClick={() => navigate("/login")}>
            Retry Login
          </button>
        </div>
      ) : (
        <div className="loading-wrapper">
          <Spin size="large" />
          <h3>Please wait...</h3>
        </div>
      )}
    </div>
  );
};

export default AdminLogin;
